import type { FC, ReactNode } from 'react'

import Link from 'next/link'

import { SOS } from '@/constants/canais'

export const HomeSos: FC = (): ReactNode => {
    return (
        <aside className='hm-sos' aria-label="Ajuda imediata">
            <p className='eyebrow hm-sos-eyebrow'>
                Em perigo agora?
            </p>

            <ul className='hm-sos-list'>
                {SOS.slice(0, 3).map(item => (
                    <li key={item.numero}>
                        <a
                            className='hm-sos-item'
                            href={item.tel}
                            aria-label={`Ligar para ${item.numero}, ${item.label}`}
                        >
                            <span className='hm-sos-num'>
                                {item.numero}
                            </span>

                            <span className='hm-sos-label'>
                                {item.label}
                            </span>
                        </a>
                    </li>
                ))}
            </ul>

            <Link href='/ajuda' className='hm-sos-more'>
                Mais canais
            </Link>
        </aside>
    )
}
